var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 mb-4"},[_c('div',{staticClass:"d-flex justify-content-between mb-2"},[_c('span',[_vm._v(" "+_vm._s(_vm.field.title)+" ")])]),_c('b-form-select',{attrs:{"options":_vm.languageList},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }